require('./SdZ/core');
require('./SdZ/langs/fr_FR');
require('./modules/constants');
require('./modules/utils/log');
require('./modules/commands');
require('./modules/anchors');
require('./modules/preferences');
require('./modules/pubsub');
require('./modules/utils/responsive');
require('./modules/confirm');
